// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class CrisisAttachedFile_abstract extends SagaObject {
  static $t: string = 'SagaSchema.CrisisAttachedFile';
  $t: string = 'SagaSchema.CrisisAttachedFile';

  public static GetMembers(): string[] {
    return ['AttachedFileUid', 'Data', 'ThumbnailData'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return CrisisAttachedFile_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public AttachedFileUid: Guid = GuidTools.Empty;
  public Data: any[];
  public ThumbnailData: any[];

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
